import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router";
import HomePage from "./Pages/Home/Home";
import AboutUsPage from "./Pages/AboutUs/AboutUs";
import ContactPage from "./Pages/Contact/Contact";
import OurValuePage from "./Pages/OurValue/OurValue";
import MainLayout from "./Layout";
import OrganizationPage from "./Pages/Organization/Organization";
import NewsPage from "./Pages/News/News";
import LoginPage from "./Pages/Login/Login";
import PrivateRoute from "./Util/PrivateRoute";
import AdminLayout from "./AdminLayout";
import DashboardPage from "./Pages/Admin/Dashboard/Dashboard";
import { AuthProvide } from "./Util/Context/AuthContext";
import NewsManagementPage from "./Pages/Admin/NewsManagement/NewsManagement";
import BrandPage from "./Pages/Brands/Brand";
import StoresPage from "./Pages/Stores/Stores";
import PartnershipPage from "./Pages/Partnership/Partnership";
import ScrollToTop from "./Util/scrollToTop";
import UnderMaintenance from "./Component/UnderMaintenance/UnderMaintenance";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvide>
        <Routes>
          <Route path="" element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="about-us" element={<AboutUsPage />}>
              {/* <Route path="organization" element={<OrganizationPage />} /> */}
            </Route>
            <Route path="our-value" element={<OurValuePage />} />
            <Route path="brands" element={<BrandPage />} />
            {/* <Route path="stores" element={<StoresPage />} /> */}
            <Route path="partnership" element={<PartnershipPage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="contact" element={<ContactPage />} />
          </Route>
          Admin Routes
          <Route path="/login" element={<LoginPage />} />
          <Route element={<PrivateRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<NewsManagementPage />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvide>
    </BrowserRouter>
    {/* <UnderMaintenance /> */}
  </React.StrictMode>,
);
